export default __webpack_public_path__ + "static/media/Mystic's Belt of the Exalted Spirit.8b332c48.jpg";